/** @format */
import { ModelPriceModifierGroup } from '@toucan/client/global/model';

export function filterModifierGroupsByAvailableOptions(
    groups: ModelPriceModifierGroup[] = [],
    availableModifierIds: number[] = []
) {
    return groups.reduce<ModelPriceModifierGroup[]>((groups, group) => {
        if (group.modifiers.length <= 1) return groups;

        const modifiers = group.modifiers.filter((modifier) =>
            availableModifierIds.includes(modifier.id)
        );

        if (!modifiers.length) return groups;

        groups.push({
            ...group,
            modifiers,
        });

        return groups;
    }, []);
}
